/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Popover, PopoverContent, PopoverTrigger } from '@chakra-ui/popover';
import { MenuItem } from '@components/menu';
import { useSnackbar } from '@components/snackbar';
import { priorityOptions, PrioritySelectSingleValueFlag } from '@sketchnote/shared-components';
import Tippy from '@tippyjs/react';
import classNames from 'classnames';
import cn from 'classnames';
import * as React from 'react';
import { useTaskAccess } from 'src/features/files/hooks/useTaskAccess';

import { useTasksStore } from '../store/useTasksStore';

const { useCallback } = React;

export const EditItemPriority = () => {
  const taskId = useTasksStore((s) => s.currentTaskId);
  const onUpdateItemField = useTasksStore((s) => s.onUpdateItemField);
  const [isPopoverOpen, setIsPopoverOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const item = useTasksStore((s) => {
    if (taskId) {
      return s.tasks[taskId];
    }
  });
  const [open] = useSnackbar();

  const { isReadOnly } = useTaskAccess(taskId || '');

  const handleChange = (value) => {
    const priority = value.value;
    if (item?.id) {
      setLoading(true);
      onUpdateItemField({ item: { priority, id: item.id }, keys: ['priority'] })
        .then((success) => {
          if (!success)
            open({
              text: 'Something went wrong',
              duration: 2000,
              position: 'top-center',
              snackType: 'error',
            });
        })
        .finally(() => setLoading(false));
    }
    setIsPopoverOpen(false);
  };

  return (
    <div>
      <Popover isOpen={!isReadOnly && isPopoverOpen} onClose={() => setIsPopoverOpen(false)}>
        <PopoverTrigger>
          <Tippy
            content={
              isReadOnly ? 'You do not have the required permission to edit tasks' : 'Priority'
            }
          >
            <button
              onClick={() => !loading && setIsPopoverOpen((p) => !p)}
              className={classNames('cursor-pointer', loading && 'opacity-50')}
            >
              <PrioritySelectSingleValueFlag data={{ value: item?.priority || '' }} />
            </button>
          </Tippy>
        </PopoverTrigger>
        <PopoverContent>
          <div className="bg-white border rounded-lg min-w-238">
            <div className="border-b px-16 py-12 text-gray-600 text-sm">Priority</div>
            <div>
              {priorityOptions.map((option) => (
                <MenuItem
                  key={option.value}
                  className={cn('px-12 py-8 flex items-center gap-8 text-gray-600 text-sm')}
                  onClick={() => handleChange({ value: option.value })}
                >
                  <PrioritySelectSingleValueFlag data={{ value: option.value }} />
                  <span>{option.label}</span>
                </MenuItem>
              ))}
            </div>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
};
